import React, { useState } from 'react';
import { Copy } from 'react-feather';

const TextEditorViewer = (props) => {
    // State to track copied items
    const [copiedItems, setCopiedItems] = useState(new Set());

    // Function to copy content to clipboard
    const handleCopy = (text, index) => {
        const textarea = document.createElement('textarea');
        // Extract the value after the defining point (in this case, after the first colon)
        const valueToCopy = text.split(':').slice(1).join(':').trim(); // Get everything after the first colon
        textarea.value = valueToCopy; // Set the specific text to copy
        document.body.appendChild(textarea);
        textarea.select();
        document.execCommand('copy'); // Copy to clipboard
        document.body.removeChild(textarea); // Remove textarea

        // Add the copied item index to the set
        setCopiedItems((prev) => new Set(prev).add(index));
    };

    // Split the HTML content into paragraphs and h4 tags, filtering out empty strings
    const content = props.data.split(/<\/?p>|<\/?h4>|<div>&nbsp;<\/div>/).filter(item => item.trim() !== ''); // Filter out empty strings and divs with &nbsp;

    return (
        <div className="body-container">
            <div className="body">
                {content.map((item, index) => {
                    // Clean text by removing HTML tags
                    const cleanText = item.replace(/<\/?[^>]+(>|$)/g, "").trim(); // Clean text for display

                    return (
                        <div key={index} style={{ marginBottom: '10px',fontSize: 14 ,display: 'flex', alignItems: 'center' }}>
                            <div dangerouslySetInnerHTML={{ __html: item }} style={{ flex: 1 }} />
                            {/* {cleanText && (
                                <button
                                    onClick={() => handleCopy(cleanText.replace(/&nbsp;/g, ""), index)} // Copy cleaned text without &nbsp;
                                    style={{
                                        marginLeft: '10px',
                                        padding: '5px 10px',
                                        border: 'none',
                                        borderRadius: '5px',
                                        cursor: 'pointer',
                                        
                                    }}
                                >
                                    <Copy size={'20'} />
                                </button>
                            )} */}
                            {copiedItems.has(index) && <span style={{ marginLeft: '10px', color: 'green' }}></span>}
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

export default TextEditorViewer;
